import { axiosSetting } from '@/utils/axiosSetting'
import dayjs from 'dayjs'
import { inject, provide, reactive } from 'vue'

const axios = axiosSetting('cms', 'block')
export const createTest = () => {
  const state = reactive({
    tests: [],
    test: {},
    totalPages: 0
  })

  const parseTest = (test: any) => ({
    id: test.id,
    question: test.acf.test_question,
    level: Number(test.acf.test_level),
    answers: test.acf.test_answers,
    category: test.acf.test_category,
    sections: test.acf.test_section,
    questionImages: test.acf.test_question_images
      ? test.acf.test_question_images.map((d: any) => d.image).filter(Boolean)
      : [],
    answerImages: test.acf.test_answer_images
      ? test.acf.test_answer_images.map((d: any) => d.image).filter(Boolean)
      : [],
    date: dayjs(test.date).format('YYYY年M月D日'),
    commentary: test.acf.commentary
  })
  const getTests = ({
    limit,
    category,
    page = 1
  }: { limit?: number; category?: number; page?: number } = {}) => {
    axios
      .get('/test', {
        params: {
          per_page: limit,
          category,
          page
        }
      })
      .then(({ data, headers }) => {
        console.log('getTests', data)
        if (limit === 1) state.test = parseTest(data[0])
        else state.tests = data.map((d: any) => parseTest(d))
        state.totalPages = Number(headers['x-wp-totalpages'])
      })
  }
  const getTest = ({ id }: { id: number }) => {
    const test = state.tests.find((d: any) => d.id === id)
    if (test) {
      state.test = test
      return
    }
    axios.get(`/test/${id}`).then(({ data }) => {
      state.test = parseTest(data)
    })
  }

  return {
    state,
    getTest,
    getTests
  }
}

export const key = Symbol()
export const provideTest = () => provide(key, createTest())
export const useTest = (): any => inject(key)
